import { Locale } from "../modules/locale";

export const submitForm = async (apiRoute: string, data: object | FormData) => {
  let body;
  if (data instanceof FormData) {
    data.append("lang", Locale.language);
    body = data;
  } else {
    body = JSON.stringify({ ...data, lang: Locale.language });
  }

  const rawResponse = await fetch(`https://hooks.zapier.com/hooks/catch/12979755/${apiRoute}/`, {
    method: "POST",
    body: body,
  });
  return await rawResponse.json();
};
